import React from "react";
import { Building2 } from "lucide-react";

// Enhanced AboutHero Component
const AboutHero = () => {
  return (
    <div
      className="relative w-full h-[70vh] overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/home_background.avif')" }}
    >
      {/* Overlay for text readability */}
      <div className="absolute inset-0 bg-black opacity-60"></div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full px-4">
        <div className="text-center max-w-4xl mx-auto">
          {/* <div className="mb-6 transform hover:scale-105 transition-transform duration-300">
            <Building2 className="w-16 h-16 mx-auto text-[#2596be] mb-4" />
          </div> */}
          <h1 className="text-white text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            About <span className="text-[#2596be]">Us</span>
          </h1>
          <p className="text-blue-100 text-xl md:text-2xl max-w-2xl mx-auto leading-relaxed mb-8">
            Your trusted commercial property experts in Sri Lanka
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#2596be] rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#2596be] rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};
export default AboutHero;
